export default __webpack_public_path__ + "static/pnc-370-aeb0e6b2ea4db87c63be38d0daaf25ac.png";